import ProhibitedNotice from './ProhibitedNotice'

export default ProhibitedNotice
